import React from 'react';

import { DateRangeFormatter } from '@gogame/intl-ts';

const IOTitle = ({ businessPartner = {}, period = [] }) => {
  return (
    <span>
      <span>{businessPartner.name} / </span>
      <DateRangeFormatter value={period} template={'MONTH'} timeZone={'utc'} />
    </span>
  );
};

export default IOTitle;
